export type Maybe<T> = T | null;


export interface RefundSaleInput {
  
  readonly customer: CustomerInput;
  /** Reason picked form a predefined dropdown list */
  readonly primaryReason: RefundReason;
  
  readonly rbiOrderId: string;
  
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItemsInput>>>;
  /** Refund amount requested by customer */
  readonly requestedAmountCents?: Maybe<number>;
  /** Reason manually added by an admin */
  readonly secondaryReason?: Maybe<string>;
}

export interface CustomerInput {
  
  readonly email: string;
  /** fdCustomerId */
  readonly id?: Maybe<string>;
  
  readonly name?: Maybe<string>;
}

export interface RefundedItemsInput {
  
  readonly name?: Maybe<string>;
  
  readonly refundAmount?: Maybe<string>;
  
  readonly refundQuantity?: Maybe<string>;
  
  readonly refundSubtotalCents?: Maybe<number>;
  
  readonly refundTaxCents?: Maybe<number>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly type?: Maybe<CartEntryType>;
}

  export enum RbiOrderStatus {
    CATERING_DECLINED = "CATERING_DECLINED",
    CATERING_ERROR = "CATERING_ERROR",
    CATERING_PLACED = "CATERING_PLACED",
    CATERING_SUCCESSFUL = "CATERING_SUCCESSFUL",
    COMMIT_ERROR = "COMMIT_ERROR",
    INSERT_ERROR = "INSERT_ERROR",
    INSERT_REQUESTED = "INSERT_REQUESTED",
    INSERT_SUCCESSFUL = "INSERT_SUCCESSFUL",
    KOUNT_DENIAL = "KOUNT_DENIAL",
    PAYMENT_ERROR = "PAYMENT_ERROR",
    PAYMENT_REQUESTED = "PAYMENT_REQUESTED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
    PRICE_ERROR = "PRICE_ERROR",
    PRICE_REQUESTED = "PRICE_REQUESTED",
    PRICE_SUCCESSFUL = "PRICE_SUCCESSFUL",
    QUEUE_ERROR = "QUEUE_ERROR",
    QUEUED = "QUEUED",
    REFUND_ERROR = "REFUND_ERROR",
    REFUND_REQUESTED = "REFUND_REQUESTED",
    REFUND_SUCCESSFUL = "REFUND_SUCCESSFUL",
    UPDATE_ERROR = "UPDATE_ERROR",
    UPDATE_REQUESTED = "UPDATE_REQUESTED",
    UPDATE_SUCCESSFUL = "UPDATE_SUCCESSFUL",
    VALIDATION_ERROR = "VALIDATION_ERROR",
  }

  export enum Brand {
    BK = "BK",
    FHS = "FHS",
    PLK = "PLK",
    TH = "TH",
  }

  export enum CartEntryType {
    COMBO = "Combo",
    COMBOSLOT = "ComboSlot",
    ITEM = "Item",
    ITEMOPTION = "ItemOption",
    ITEMOPTIONMODIFIER = "ItemOptionModifier",
    OFFERCOMBO = "OfferCombo",
    OFFERDISCOUNT = "OfferDiscount",
    OFFERITEM = "OfferItem",
    PREPAIDOFFER = "PrepaidOffer",
  }

  export enum Platform {
    APP = "app",
    GOOGLEFOODORDERING = "googleFoodOrdering",
    KIOSK = "kiosk",
    WEB = "web",
  }

  export enum PosVendor {
    CARROLS = "CARROLS",
    NCR = "NCR",
    QDI = "QDI",
    QST = "QST",
    SICOM = "SICOM",
  }

  export enum ServiceMode {
    CATERING_DELIVERY = "CATERING_DELIVERY",
    CATERING_PICKUP = "CATERING_PICKUP",
    CURBSIDE = "CURBSIDE",
    DELIVERY = "DELIVERY",
    DRIVE_THRU = "DRIVE_THRU",
    EAT_IN = "EAT_IN",
    TABLE_SERVICE = "TABLE_SERVICE",
    TAKEOUT = "TAKEOUT",
  }

  export enum CateringDeclineReasons {
    CATERING_ORDER_TIME_OUT = "CATERING_ORDER_TIME_OUT",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    INVENTORY = "INVENTORY",
    STAFFING = "STAFFING",
    TIMING = "TIMING",
  }

  export enum DeliveryStatus {
    DRIVER_ASSIGNED = "DRIVER_ASSIGNED",
    DRIVER_AT_CUSTOMER = "DRIVER_AT_CUSTOMER",
    DRIVER_AT_STORE = "DRIVER_AT_STORE",
    DRIVER_STARTING = "DRIVER_STARTING",
    DRIVER_UNASSIGNED = "DRIVER_UNASSIGNED",
    ORDER_ABANDONED = "ORDER_ABANDONED",
    ORDER_CANCELLED = "ORDER_CANCELLED",
    ORDER_CREATED = "ORDER_CREATED",
    ORDER_DROPPED_OFF = "ORDER_DROPPED_OFF",
    ORDER_ERROR = "ORDER_ERROR",
    ORDER_PICKED_UP = "ORDER_PICKED_UP",
    ORDER_TIMEOUT = "ORDER_TIMEOUT",
    QUOTE_ERROR = "QUOTE_ERROR",
    QUOTE_REQUESTED = "QUOTE_REQUESTED",
    QUOTE_SUCCESSFUL = "QUOTE_SUCCESSFUL",
    QUOTE_UNAVAILABLE = "QUOTE_UNAVAILABLE",
  }

  export enum RefundReason {
    CATERING_ORDER_DECLINED = "CATERING_ORDER_DECLINED",
    CATERING_ORDER_ERROR = "CATERING_ORDER_ERROR",
    CATERING_ORDER_TIME_OUT = "CATERING_ORDER_TIME_OUT",
    CUSTOMER_OVERCHARGED = "CUSTOMER_OVERCHARGED",
    CUSTOMER_REQUESTED_CANCEL_ORDER = "CUSTOMER_REQUESTED_CANCEL_ORDER",
    FOOD_QUALITY_ISSUE = "FOOD_QUALITY_ISSUE",
    INCORRECT_CUSTOMIZATION = "INCORRECT_CUSTOMIZATION",
    ITEMS_OUT_OF_STOCK = "ITEMS_OUT_OF_STOCK",
    MISSING_OR_INCORRECT_ITEM = "MISSING_OR_INCORRECT_ITEM",
    MOBILE_ORDERING_TECHNICAL_ISSUE = "MOBILE_ORDERING_TECHNICAL_ISSUE",
    ORDER_ARRIVED_LATE = "ORDER_ARRIVED_LATE",
    ORDER_CANCELLED = "ORDER_CANCELLED",
    ORDER_COMMIT_ERROR = "ORDER_COMMIT_ERROR",
    ORDER_NEVER_ARRIVED = "ORDER_NEVER_ARRIVED",
    ORDER_WAS_DAMAGED = "ORDER_WAS_DAMAGED",
    OTHER_ADD_COMMENT = "OTHER_ADD_COMMENT",
    RECEIVED_INCORRECT_ORDER = "RECEIVED_INCORRECT_ORDER",
    RESTAURANT_CLOSED = "RESTAURANT_CLOSED",
    RESTAURANT_COULDNT_FIND_ORDER = "RESTAURANT_COULDNT_FIND_ORDER",
  }

  export enum RbiOrderPaymentStatus {
    AUTHORIZATION_ERROR = "AUTHORIZATION_ERROR",
    AUTHORIZATION_REQUESTED = "AUTHORIZATION_REQUESTED",
    AUTHORIZATION_SUCCESSFUL = "AUTHORIZATION_SUCCESSFUL",
    CANCEL_ERROR = "CANCEL_ERROR",
    CANCEL_REQUESTED = "CANCEL_REQUESTED",
    CANCEL_SUCCESSFUL = "CANCEL_SUCCESSFUL",
    CAPTURE_ERROR = "CAPTURE_ERROR",
    CAPTURE_REQUESTED = "CAPTURE_REQUESTED",
    CAPTURE_SUCCESSFUL = "CAPTURE_SUCCESSFUL",
    PAYMENT_ERROR = "PAYMENT_ERROR",
    PAYMENT_PENDING_3DS = "PAYMENT_PENDING_3DS",
    PAYMENT_REQUESTED = "PAYMENT_REQUESTED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL",
    REFUND_ERROR = "REFUND_ERROR",
    REFUND_REQUESTED = "REFUND_REQUESTED",
    REFUND_SUCCESSFUL = "REFUND_SUCCESSFUL",
    VOID_ERROR = "VOID_ERROR",
    VOID_REQUESTED = "VOID_REQUESTED",
    VOID_SUCCESSFUL = "VOID_SUCCESSFUL",
  }


export type Json = any;




// ====================================================
// Scalars
// ====================================================







// ====================================================
// Types
// ====================================================



export interface Query {
  /** API Metadata */
  readonly api?: Maybe<ApiMetadata>;
  /** Look up Customer by email or customerId */
  readonly Customer?: Maybe<CustomerDetails>;
  /** Look up Customer by their email address */
  readonly customerByEmail?: Maybe<CustomerInfo>;
  /** Look up Customer by their loyalty id */
  readonly customerByLoyaltyId?: Maybe<BaseCustomer>;
  /** Look up Customers by their email address */
  readonly customersByEmail?: Maybe<ReadonlyArray<Maybe<CustomerDetails>>>;
  /** Search customers by phone number */
  readonly customersByPhoneNumber?: Maybe<ReadonlyArray<Maybe<CustomerInfo>>>;
  
  readonly getSupportUsers: SupportUsers;
  /** Search guest lookup rows by email and return distinct allowed regions. */
  readonly guestLookupByEmail: ReadonlyArray<GuestLookupResult>;
  /** Get list of guest orders by email */
  readonly guestOrders: OrderListResponse;
  
  readonly intlCustomerLoyaltyTierConfig?: Maybe<IntlCustomerLoyaltyTierConfig>;
  
  readonly intlLoyaltyIdByEmail?: Maybe<string>;
  
  readonly intlLoyaltyOffersByLoyaltyId?: Maybe<ReadonlyArray<Maybe<IntlLoyaltyPersonalizedOffer>>>;
  
  readonly intlLoyaltyTransaction?: Maybe<IntlLoyaltyTransaction>;
  
  readonly intlLoyaltyTransactions?: Maybe<ReadonlyArray<Maybe<IntlLoyaltyTransaction>>>;
  
  readonly intlLoyaltyTransactionsWithRewardItems?: Maybe<ReadonlyArray<Maybe<IntlLoyaltyTransactionsWithRewardItems>>>;
  
  readonly intlLoyaltyUserById?: Maybe<IntlLoyaltyUser>;
  /** Query whether a customer is seeing the feature flag based on their cognitoId and country */
  readonly LaunchDarklyFlag: LaunchDarklyFlagResponse;
  
  readonly loyaltyByCustomerId?: Maybe<Loyalty>;
  
  readonly loyaltyByEmail?: Maybe<Loyalty>;
  
  readonly loyaltyByTHLegacyCognitoId?: Maybe<Loyalty>;
  
  readonly me: User;
  /** Query an order by order id */
  readonly Order?: Maybe<Order>;
  /** Get list of orders by a customer's email */
  readonly orders: OrderListResponse;
  /** Query a store by store id */
  readonly store?: Maybe<Store>;
  
  readonly stores?: Maybe<ReadonlyArray<Maybe<Store>>>;
}


export interface ApiMetadata {
  /** Pong! Simple health check. */
  readonly ping: string;
}


export interface CustomerDetails {
  
  readonly assignedOffers?: Maybe<AssignedOffers>;
  
  readonly blockState?: Maybe<BlockState>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly creditCards?: Maybe<ReadonlyArray<Maybe<CreditCard>>>;
  
  readonly customerId?: Maybe<string>;
  
  readonly defaultFdAccountId?: Maybe<string>;
  
  readonly deliveryAddresses?: Maybe<ReadonlyArray<Maybe<DeliveryAddress>>>;
  
  readonly dob?: Maybe<string>;
  
  readonly email?: Maybe<string>;
  
  readonly fdCustomerId?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly optedInLoyalty?: Maybe<boolean>;
  
  readonly orders?: Maybe<OrderListResponse>;
  
  readonly ordersByIds?: Maybe<OrderListResponse>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly phoneVerified?: Maybe<boolean>;
  
  readonly pointsRemediations?: Maybe<ReadonlyArray<Maybe<Remediation>>>;
  
  readonly promotionalEmails?: Maybe<boolean>;
  
  readonly refundCounts?: Maybe<RefundCounts>;
  
  readonly remediationReasons?: Maybe<ReadonlyArray<Maybe<RemediationReason>>>;
  
  readonly remediations?: Maybe<RemediationListResponse>;
  
  readonly removalReasons?: Maybe<ReadonlyArray<Maybe<RemediationReason>>>;
  
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<SecondaryIdentifier>>>;
  
  readonly supportOffers?: Maybe<ReadonlyArray<Maybe<SanityOffer>>>;
  
  readonly thLegacyCognitoId?: Maybe<string>;
  
  readonly zipCode?: Maybe<string>;
}


export interface AssignedOffers {
  
  readonly offers?: Maybe<ReadonlyArray<Maybe<Offer>>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface Offer {
  
  readonly agentEmail?: Maybe<string>;
  
  readonly assignedBy?: Maybe<string>;
  
  readonly assignedDate?: Maybe<string>;
  
  readonly challengeGoals?: Maybe<string>;
  
  readonly challengeReward?: Maybe<string>;
  
  readonly comments?: Maybe<string>;
  
  readonly compensationOrderId?: Maybe<string>;
  
  readonly couponId?: Maybe<string>;
  
  readonly expiryDate?: Maybe<string>;
  
  readonly id: string;
  
  readonly isActive?: Maybe<boolean>;
  
  readonly loyaltyEngineId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly offerTemplateId?: Maybe<string>;
  
  readonly rbiOrderId?: Maybe<string>;
  
  readonly reason?: Maybe<string>;
  
  readonly redemptionDate?: Maybe<string>;
  
  readonly redemptionSteps?: Maybe<ReadonlyArray<Maybe<string>>>;
  
  readonly removalComments?: Maybe<string>;
  
  readonly removalReason?: Maybe<string>;
  
  readonly removedAt?: Maybe<string>;
  
  readonly removedBy?: Maybe<string>;
  
  readonly terms?: Maybe<string>;
  
  readonly tokenId?: Maybe<string>;
}


export interface BlockState {
  
  readonly isBlocked?: Maybe<boolean>;
}


export interface CreditCard {
  /** Credit card last 4 digits */
  readonly alias: string;
  /** Billing address details */
  readonly billingAddress?: Maybe<BillingAddress>;
  /** Card type, e.g. 'Mastercard' */
  readonly cardType: string;
  /** Date created */
  readonly createdAt: string;
  /** Two digit expiry month */
  readonly expiryMonth: string;
  /** Two digit expiry year */
  readonly expiryYear: string;
}


export interface BillingAddress {
  /** City */
  readonly locality?: Maybe<string>;
  /** Zip Code */
  readonly postalCode?: Maybe<string>;
  /** State */
  readonly region?: Maybe<string>;
  /** Street Address */
  readonly streetAddress?: Maybe<string>;
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<string>;
}


export interface DeliveryAddress {
  
  readonly addressLine1?: Maybe<string>;
  
  readonly addressLine2?: Maybe<string>;
  
  readonly alias?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly country?: Maybe<string>;
  
  readonly latitude?: Maybe<number>;
  
  readonly longitude?: Maybe<number>;
  
  readonly route?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly streetNumber?: Maybe<string>;
  
  readonly zip?: Maybe<string>;
}


export interface OrderListResponse {
  
  readonly count: number;
  
  readonly orders?: Maybe<ReadonlyArray<Maybe<Order>>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface Order {
  
  readonly cart: Cart;
  
  readonly catering?: Maybe<Catering>;
  
  readonly claimOrderId?: Maybe<string>;
  
  readonly createdAt: string;
  
  readonly curbsideLicensePlateNumber?: Maybe<string>;
  
  readonly curbsideParkingSpot?: Maybe<string>;
  
  readonly customer?: Maybe<CustomerDetails>;
  
  readonly delivery?: Maybe<Delivery>;
  
  readonly deliveryTimeline?: Maybe<ReadonlyArray<Maybe<DeliveryEvent>>>;
  
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorDetails>>>;
  
  readonly isPrepaidOrder?: Maybe<boolean>;
  
  readonly loyaltyTransaction?: Maybe<LoyaltyTransactionForOrder>;
  
  readonly order?: Maybe<RbiOrder>;
  
  readonly paymentAuditEvent?: Maybe<PaymentAuditEvent>;
  
  readonly paymentStatus?: Maybe<RbiOrderPaymentStatus>;
  
  readonly paymentVersion?: Maybe<number>;
  
  readonly pk: string;
  
  readonly posOrderId?: Maybe<string>;
  
  readonly posVendor: string;
  
  readonly rbiOrderId: string;
  
  readonly redeliveryOrderId?: Maybe<string>;
  
  readonly region?: Maybe<string>;
  
  readonly remediations?: Maybe<ReadonlyArray<Maybe<Remediation>>>;
  
  readonly revision: number;
  
  readonly scheduledPickupAt?: Maybe<string>;
  
  readonly sk: string;
  
  readonly status: RbiOrderStatus;
  
  readonly updatedAt: string;
  
  readonly userId?: Maybe<string>;
}


export interface Cart {
  
  readonly brand: Brand;
  
  readonly cartEntries?: Maybe<ReadonlyArray<Maybe<CartEntries>>>;
  
  readonly customerName: string;
  
  readonly discounts?: Maybe<ReadonlyArray<Maybe<Discount>>>;
  
  readonly donations?: Maybe<ReadonlyArray<Maybe<Donation>>>;
  
  readonly feCountryCode?: Maybe<string>;
  
  readonly fees?: Maybe<ReadonlyArray<Maybe<Fee>>>;
  
  readonly guestDetails?: Maybe<GuestDetails>;
  
  readonly guestId?: Maybe<string>;
  
  readonly payment?: Maybe<Payment>;
  
  readonly platform?: Maybe<Platform>;
  
  readonly posVendor?: Maybe<PosVendor>;
  
  readonly requestedAmountCents: number;
  
  readonly serviceMode?: Maybe<ServiceMode>;
  
  readonly storeAddress?: Maybe<StoreAddress>;
  
  readonly storeDetails?: Maybe<StoreDetails>;
  
  readonly storeId?: Maybe<string>;
  
  readonly storePosId?: Maybe<string>;
  
  readonly subTotalCents?: Maybe<number>;
  
  readonly subTotalPaidCents?: Maybe<number>;
  
  readonly taxCents?: Maybe<number>;
  
  readonly taxPaidCents?: Maybe<number>;
  
  readonly ticketNumber?: Maybe<string>;
  
  readonly totalCents?: Maybe<number>;
  
  readonly totalPaidCents?: Maybe<number>;
  /** CartEntry IDs marked as unavailable by the pricing response (Connector only for now) */
  readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<UnavailableCartEntry>>>;
  
  readonly userDetails?: Maybe<UserDetails>;
  
  readonly userId?: Maybe<string>;
}


export interface CartEntries {
  
  readonly children?: Maybe<ReadonlyArray<Maybe<CartEntries>>>;
  
  readonly image?: Maybe<string>;
  
  readonly isUpsell?: Maybe<boolean>;
  
  readonly lineId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly offerVendorConfigs?: Maybe<VendorConfigs>;
  
  readonly pickerSelections?: Maybe<string>;
  
  readonly plu?: Maybe<Plu>;
  
  readonly price?: Maybe<number>;
  
  readonly productHierarchy?: Maybe<ProductHierarchy>;
  
  readonly quantity: number;
  
  readonly redeemable?: Maybe<boolean>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly triggerUpsellItemId?: Maybe<string>;
  
  readonly type: CartEntryType;
  
  readonly url?: Maybe<string>;
  
  readonly vendorConfigs?: Maybe<VendorConfigs>;
}


export interface VendorConfigs {
  
  readonly carrols?: Maybe<VendorConfig>;
  
  readonly carrolsDelivery?: Maybe<VendorConfig>;
  
  readonly ncr?: Maybe<VendorConfig>;
  
  readonly ncrDelivery?: Maybe<VendorConfig>;
  
  readonly productNumber?: Maybe<VendorConfig>;
  
  readonly sicom?: Maybe<VendorConfig>;
  
  readonly sicomDelivery?: Maybe<VendorConfig>;
}


export interface VendorConfig {
  
  readonly constantPlu?: Maybe<string>;
  
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<QuantityPlu>>>;
  
  readonly parentChildPlu?: Maybe<ParentChildPlu>;
  
  readonly parentSanityId?: Maybe<string>;
  
  readonly pluType: string;
  
  readonly pullUpLevels?: Maybe<number>;
  
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<QuantityPlu>>>;
  
  readonly sizeBasedPlu?: Maybe<SizeBasedPlu>;
}


export interface QuantityPlu {
  
  readonly plu: string;
  
  readonly qualifier?: Maybe<string>;
  
  readonly quantity: number;
}


export interface ParentChildPlu {
  
  readonly childPlu: string;
  
  readonly plu: string;
}


export interface SizeBasedPlu {
  
  readonly comboPlu: string;
  
  readonly comboSize: string;
}


export interface Plu {
  
  readonly connector?: Maybe<string>;
  
  readonly ncr?: Maybe<string>;
  
  readonly ncrDelivery?: Maybe<string>;
  
  readonly productNumber?: Maybe<string>;
  
  readonly qst?: Maybe<string>;
  
  readonly sicom?: Maybe<string>;
  
  readonly sicomDelivery?: Maybe<string>;
}


export interface ProductHierarchy {
  
  readonly L1?: Maybe<string>;
  
  readonly L2?: Maybe<string>;
  
  readonly L3?: Maybe<string>;
  
  readonly L4?: Maybe<string>;
  
  readonly L5?: Maybe<string>;
}


export interface Discount {
  
  readonly name: string;
  
  readonly value: number;
}


export interface Donation {
  
  readonly id: string;
  
  readonly name: string;
  
  readonly totalCents: number;
}


export interface Fee {
  
  readonly name: string;
  
  readonly priceCents: number;
  
  readonly quantity: number;
  
  readonly totalCents: number;
}


export interface GuestDetails {
  
  readonly guestEmail?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
}


export interface Payment {
  
  readonly cardType?: Maybe<string>;
  
  readonly ccExpiryMonth?: Maybe<string>;
  
  readonly ccExpiryYear?: Maybe<string>;
  
  readonly ccLast4?: Maybe<string>;
  
  readonly fdCorrelationId?: Maybe<string>;
  
  readonly fdCustomerId?: Maybe<string>;
  
  readonly fdSaleId?: Maybe<string>;
  
  readonly paymentMethodBrand?: Maybe<string>;
  
  readonly paymentType?: Maybe<string>;
}


export interface StoreAddress {
  
  readonly addressLine1: string;
  
  readonly addressLine2?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly country?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly zip: string;
}


export interface StoreDetails {
  
  readonly amenities?: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>;
  
  readonly deliveryHours?: Maybe<StoreHours>;
  
  readonly diningRoomHours?: Maybe<StoreHours>;
  
  readonly driveThruHours?: Maybe<StoreHours>;
  
  readonly franchiseGroupId?: Maybe<number>;
  
  readonly franchiseGroupName?: Maybe<string>;
  
  readonly hasCatering?: Maybe<boolean>;
  
  readonly hasDelivery?: Maybe<boolean>;
  
  readonly hasDineIn?: Maybe<boolean>;
  
  readonly hasDriveThru?: Maybe<boolean>;
  
  readonly hasMobileOrdering?: Maybe<boolean>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<string>;
  
  readonly latitude?: Maybe<number>;
  
  readonly longitude?: Maybe<number>;
  
  readonly mobileOrderingStatus?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly storeNumber?: Maybe<string>;
  
  readonly timezone?: Maybe<string>;
}


export interface IRestaurantAmenity {
  
  readonly name?: Maybe<IRestaurantAmenityName>;
}


export interface IRestaurantAmenityName {
  
  readonly _type?: Maybe<string>;
  
  readonly en?: Maybe<string>;
}


export interface StoreHours {
  
  readonly friday?: Maybe<Day>;
  
  readonly monday?: Maybe<Day>;
  
  readonly saturday?: Maybe<Day>;
  
  readonly sunday?: Maybe<Day>;
  
  readonly thursday?: Maybe<Day>;
  
  readonly tuesday?: Maybe<Day>;
  
  readonly wednesday?: Maybe<Day>;
}


export interface Day {
  
  readonly close?: Maybe<string>;
  
  readonly open?: Maybe<string>;
}


export interface UnavailableCartEntry {
  
  readonly lineId?: Maybe<string>;
  
  readonly sanityId: string;
}


export interface UserDetails {
  
  readonly createdAt?: Maybe<string>;
  
  readonly dob?: Maybe<string>;
  
  readonly email?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly promotionalEmails?: Maybe<string>;
  
  readonly zip?: Maybe<string>;
}


export interface Catering {
  
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  
  readonly notes?: Maybe<string>;
  
  readonly pickupTime: string;
}


export interface Delivery {
  
  readonly assignedFleetName?: Maybe<string>;
  
  readonly baseServiceFeeCents?: Maybe<number>;
  
  readonly distanceServiceFeeCents?: Maybe<number>;
  
  readonly driver?: Maybe<DeliveryDriver>;
  
  readonly dropoff?: Maybe<Dropoff>;
  
  readonly feeCents?: Maybe<number>;
  
  readonly feeDiscountCents?: Maybe<number>;
  
  readonly fleetId?: Maybe<string>;
  
  readonly lateNightServiceFeeCents?: Maybe<number>;
  
  readonly selectedPreOrderTimeSlot?: Maybe<PreOrderTimeSlot>;
  
  readonly serviceFeeCents?: Maybe<number>;
  
  readonly serviceFeeDiscountCents?: Maybe<number>;
  
  readonly smallCartFeeCents?: Maybe<number>;
  
  readonly status?: Maybe<DeliveryStatus>;
  
  readonly tipCents?: Maybe<number>;
  
  readonly weatherServiceFeeCents?: Maybe<number>;
}


export interface DeliveryDriver {
  
  readonly driverId?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly profileImageUrl?: Maybe<string>;
}


export interface PreOrderTimeSlot {
  
  readonly end?: Maybe<string>;
  
  readonly start?: Maybe<string>;
}


export interface Dropoff {
  
  readonly addressLine1?: Maybe<string>;
  
  readonly addressLine2?: Maybe<string>;
  
  readonly beforeTime?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly streetNumber?: Maybe<string>;
}


export interface DeliveryEvent {
  
  readonly status?: Maybe<DeliveryStatus>;
  
  readonly time?: Maybe<string>;
}


export interface ErrorDetails {
  
  readonly code: string;
  
  readonly message: string;
}


export interface LoyaltyTransactionForOrder {
  
  readonly bonusPointsEarned?: Maybe<number>;
  
  readonly pointsBalance?: Maybe<number>;
  
  readonly pointsEarned?: Maybe<number>;
  
  readonly pointsUsed?: Maybe<number>;
  
  readonly rewardsUsed?: Maybe<number>;
}


export interface RbiOrder {
  
  readonly currency?: Maybe<string>;
  
  readonly refund?: Maybe<RefundDetails>;
}


export interface RefundDetails {
  /** Admin user who issued the refund, if available */
  readonly adminUserEmail?: Maybe<string>;
  
  readonly approvedAmount: string;
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason;
  
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<RefundedItem>>>;
  
  readonly refundMethod?: Maybe<string>;
  /** Optional reason manually added by an admin */
  readonly secondaryReason?: Maybe<string>;
  
  readonly subtotal: string;
  
  readonly tax: string;
  /** Date time when refund was issued */
  readonly transactionDateTime: string;
}


export interface RefundedItem {
  
  readonly name?: Maybe<string>;
  
  readonly plu: Plu;
  
  readonly refundAmount?: Maybe<string>;
  
  readonly refundQuantity?: Maybe<string>;
  
  readonly sanityId?: Maybe<string>;
  
  readonly type?: Maybe<CartEntryType>;
}


export interface PaymentAuditEvent {
  
  readonly auditLogId?: Maybe<string>;
  
  readonly context?: Maybe<PaymentAuditEventContext>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly eventId?: Maybe<string>;
  
  readonly userId?: Maybe<string>;
}


export interface PaymentAuditEventContext {
  
  readonly amountCents?: Maybe<number>;
  
  readonly currency?: Maybe<string>;
  
  readonly failureReason?: Maybe<string>;
  
  readonly fdSaleId?: Maybe<string>;
  
  readonly isSuccessful?: Maybe<boolean>;
  
  readonly transactionId?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface Remediation {
  
  readonly amount?: Maybe<number>;
  
  readonly created: string;
  
  readonly displayName: string;
  
  readonly remediationComments?: Maybe<string>;
  
  readonly remediationReason?: Maybe<string>;
  
  readonly remediationType: string;
  
  readonly sanityId?: Maybe<string>;
  
  readonly secondaryTransactionId?: Maybe<string>;
  
  readonly secondaryTransactionType?: Maybe<string>;
  
  readonly supportEmail: string;
  
  readonly transactionId?: Maybe<string>;
  
  readonly transactionType?: Maybe<string>;
  
  readonly userId: string;
}


export interface RefundCounts {
  
  readonly autoRefundable?: Maybe<boolean>;
  
  readonly fullRefunds?: Maybe<number>;
  
  readonly ordersForRefundPercentage?: Maybe<number>;
  
  readonly partialRefunds?: Maybe<number>;
}


export interface RemediationReason {
  
  readonly label?: Maybe<string>;
  
  readonly value?: Maybe<string>;
}


export interface RemediationListResponse {
  
  readonly remediations: ReadonlyArray<Maybe<Remediation>>;
  
  readonly resumeAfter?: Maybe<string>;
}


export interface SecondaryIdentifier {
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
}


export interface SanityOffer {
  
  readonly _id: string;
  
  readonly _type: string;
  
  readonly configIncentive?: Maybe<ConfigIncentive>;
  
  readonly loyaltyEngineId?: Maybe<string>;
  
  readonly monetaryValueCents: number;
  
  readonly name?: Maybe<string>;
}


export interface ConfigIncentive {
  
  readonly loyaltyEngineId?: Maybe<string>;
}


export interface CustomerInfo {
  
  readonly details?: Maybe<CustomerDetails>;
}


export interface BaseCustomer {
  
  readonly customerId: string;
  
  readonly email: string;
  
  readonly isoCountryCode?: Maybe<string>;
}


export interface SupportUsers {
  
  readonly resumeAfter?: Maybe<string>;
  
  readonly users: ReadonlyArray<Maybe<SupportUser>>;
}


export interface SupportUser {
  
  readonly email: string;
  
  readonly groups: ReadonlyArray<Maybe<string>>;
  
  readonly metrics?: Maybe<ReadonlyArray<Maybe<string>>>;
  
  readonly status: string;
  
  readonly username: string;
}


export interface GuestLookupResult {
  
  readonly email: string;
  
  readonly region: string;
}


export interface IntlCustomerLoyaltyTierConfig {
  
  readonly configurationTier?: Maybe<IntlLoyaltyTierConfiguration>;
  
  readonly customerTier?: Maybe<IntlCustomerTier>;
  
  readonly enableLoyaltyTiers?: Maybe<boolean>;
}


export interface IntlLoyaltyTierConfiguration {
  
  readonly loyaltyTierKey?: Maybe<string>;
  
  readonly pointsNeeded?: Maybe<number>;
  
  readonly pointsNeededToMaintain?: Maybe<number>;
  
  readonly pointsToEnterCalculationTimeInterval?: Maybe<number>;
  
  readonly pointsToEnterCalculationTimeUnit?: Maybe<string>;
  
  readonly pointsToMaintainCalculationTimeInterval?: Maybe<number>;
  
  readonly pointsToMaintainCalculationTimeUnit?: Maybe<string>;
}


export interface IntlCustomerTier {
  
  readonly loyaltyTierExpiryDate?: Maybe<string>;
  
  readonly loyaltyTierKey?: Maybe<string>;
  
  readonly pointsEarnedInTimeConstraint?: Maybe<number>;
  
  readonly startAt?: Maybe<string>;
}


export interface IntlLoyaltyPersonalizedOffer {
  
  readonly configId?: Maybe<string>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly endDate?: Maybe<string>;
  
  readonly errors?: Maybe<ReadonlyArray<Maybe<IntlLoyaltyOfferError>>>;
  
  readonly id: string;
  
  readonly loyaltyId: string;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly name?: Maybe<string>;
  
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<string>>>;
  
  readonly sourceId?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface IntlLoyaltyOfferError {
  
  readonly code?: Maybe<string>;
  
  readonly currentValue?: Maybe<string>;
  
  readonly incentiveId?: Maybe<string>;
  
  readonly message?: Maybe<string>;
  
  readonly ruleId?: Maybe<string>;
  
  readonly targetValue?: Maybe<string>;
}


export interface Metadata {
  
  readonly agentEmail?: Maybe<string>;
  
  readonly assignedBy?: Maybe<string>;
  
  readonly comments?: Maybe<string>;
  
  readonly createdAt?: Maybe<string>;
  
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ExternalIdentifiers>>>;
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
  
  readonly maxTransactionLimitReached?: Maybe<boolean>;
  
  readonly name?: Maybe<string>;
  
  readonly orderId?: Maybe<string>;
  
  readonly remediationReason?: Maybe<string>;
  
  readonly removalComments?: Maybe<string>;
  
  readonly removedBy?: Maybe<string>;
  
  readonly source?: Maybe<string>;
}


export interface ExternalIdentifiers {
  
  readonly type?: Maybe<string>;
  
  readonly value?: Maybe<string>;
}


export interface IntlLoyaltyTransaction {
  
  readonly additionalReferenceIds?: Maybe<ReadonlyArray<Maybe<AdditionalReferenceIds>>>;
  
  readonly bonusPointsEarned: number;
  
  readonly channel: string;
  
  readonly createdAt: string;
  
  readonly currency?: Maybe<string>;
  
  readonly id: string;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly pointsDeducted?: Maybe<number>;
  
  readonly pointsEarned: number;
  
  readonly pointsUsed: number;
  
  readonly rbiOrderId?: Maybe<string>;
  
  readonly rewardIds: ReadonlyArray<Maybe<string>>;
  
  readonly shortId?: Maybe<string>;
  
  readonly status: string;
  
  readonly store?: Maybe<Store>;
  
  readonly storeId?: Maybe<string>;
  
  readonly total: number;
  
  readonly transactionDetails?: Maybe<IntlTransactionDetails>;
}


export interface AdditionalReferenceIds {
  
  readonly id?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface Store {
  
  readonly _id: string;
  
  readonly amenities?: Maybe<ReadonlyArray<Maybe<IRestaurantAmenity>>>;
  
  readonly deliveryHours?: Maybe<StoreHours>;
  
  readonly diningRoomHours?: Maybe<StoreHours>;
  
  readonly driveThruHours?: Maybe<StoreHours>;
  
  readonly franchiseGroupId?: Maybe<number>;
  
  readonly freeDeliveryPromoConfiguration?: Maybe<FreeDeliveryPromoConfiguration>;
  
  readonly hasCatering?: Maybe<boolean>;
  
  readonly hasDelivery?: Maybe<boolean>;
  
  readonly hasDineIn?: Maybe<boolean>;
  
  readonly hasDriveThru?: Maybe<boolean>;
  
  readonly hasMobileOrdering?: Maybe<boolean>;
  
  readonly hasTakeOut?: Maybe<boolean>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<string>;
  
  readonly latitude?: Maybe<number>;
  
  readonly longitude?: Maybe<number>;
  
  readonly mobileOrderingStatus?: Maybe<string>;
  
  readonly phoneNumber?: Maybe<string>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly status?: Maybe<string>;
  
  readonly storeAddress?: Maybe<SanityStoreAddress>;
  
  readonly storeNumber?: Maybe<string>;
  
  readonly timezone?: Maybe<string>;
}


export interface FreeDeliveryPromoConfiguration {
  
  readonly endDateTime?: Maybe<string>;
  
  readonly startDateTime?: Maybe<string>;
}


export interface SanityStoreAddress {
  
  readonly address1?: Maybe<string>;
  
  readonly address2?: Maybe<string>;
  
  readonly city?: Maybe<string>;
  
  readonly country?: Maybe<string>;
  
  readonly postalCode?: Maybe<string>;
  
  readonly state?: Maybe<string>;
  
  readonly stateProvince?: Maybe<string>;
  
  readonly stateProvinceShort?: Maybe<string>;
}


export interface IntlTransactionDetails {
  
  readonly fulfillment?: Maybe<IntlFulfillment>;
  
  readonly orders?: Maybe<ReadonlyArray<Maybe<TransactionOrders>>>;
  
  readonly payments?: Maybe<ReadonlyArray<Maybe<Payments>>>;
  
  readonly person?: Maybe<Person>;
  
  readonly posVendor?: Maybe<IntlLoyaltyPosVendor>;
  
  readonly promotions?: Maybe<ReadonlyArray<Maybe<IntlIncentive>>>;
}


export interface IntlFulfillment {
  
  readonly type?: Maybe<string>;
}


export interface TransactionOrders {
  
  readonly couponId?: Maybe<string>;
  
  readonly incentivePlu?: Maybe<string>;
  
  readonly lineId?: Maybe<string>;
  
  readonly parentReferenceId?: Maybe<string>;
  
  readonly plu?: Maybe<string>;
  
  readonly pluDocuments?: Maybe<ReadonlyArray<Maybe<PluDocument>>>;
  
  readonly posVendor?: Maybe<string>;
  
  readonly price?: Maybe<string>;
  
  readonly productId?: Maybe<string>;
  
  readonly productType?: Maybe<string>;
  
  readonly quantity?: Maybe<string>;
  
  readonly tax?: Maybe<string>;
}


export interface PluDocument {
  
  readonly name?: Maybe<string>;
}


export interface Payments {
  
  readonly amount?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface Person {
  
  readonly currentLoyaltyTier?: Maybe<IntlCurrentLoyaltyTier>;
  
  readonly currentPoints?: Maybe<string>;
}


export interface IntlCurrentLoyaltyTier {
  
  readonly loyaltyTierExpiryDate?: Maybe<string>;
  
  readonly loyaltyTierKey?: Maybe<string>;
  
  readonly pointsEarnedInTimeConstraint?: Maybe<number>;
  
  readonly startAt?: Maybe<string>;
}


export interface IntlLoyaltyPosVendor {
  
  readonly terminalId?: Maybe<string>;
  
  readonly transactionId?: Maybe<string>;
  
  readonly type?: Maybe<string>;
}


export interface IntlIncentive {
  
  readonly id?: Maybe<string>;
  
  readonly metadata?: Maybe<Metadata>;
  
  readonly type?: Maybe<string>;
}


export interface IntlLoyaltyTransactionsWithRewardItems {
  
  readonly redeemedItems?: Maybe<ReadonlyArray<Maybe<RedeemedItem>>>;
  
  readonly transaction?: Maybe<IntlLoyaltyTransaction>;
}


export interface RedeemedItem {
  
  readonly name?: Maybe<string>;
  
  readonly pointCost?: Maybe<number>;
}


export interface IntlLoyaltyUser {
  
  readonly cognitoId?: Maybe<string>;
  
  readonly createdAt: string;
  
  readonly dateOfBirth?: Maybe<string>;
  
  readonly email: string;
  
  readonly id: string;
  
  readonly name?: Maybe<string>;
  
  readonly points: number;
  
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<SecondaryIdentifier>>>;
  
  readonly supportPoints?: Maybe<number>;
  
  readonly supportPointsTransactions?: Maybe<number>;
  
  readonly transactions?: Maybe<ReadonlyArray<Maybe<IntlLoyaltyTransaction>>>;
}


export interface LaunchDarklyFlagResponse {
  /** Value of the LaunchDarkly flag evaluated, i.e. whether it is on or off */
  readonly response: boolean;
}


export interface Loyalty {
  
  readonly customer?: Maybe<LoyaltyUserDetails>;
  
  readonly loyaltyCard?: Maybe<LoyaltyCard>;
}


export interface LoyaltyUserDetails {
  
  readonly activeSince?: Maybe<string>;
  
  readonly customerId?: Maybe<string>;
  
  readonly dob?: Maybe<string>;
  
  readonly email?: Maybe<string>;
  
  readonly isoCountryCode?: Maybe<string>;
  
  readonly loyaltyTier?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly thLegacyCognitoId?: Maybe<string>;
}


export interface LoyaltyCard {
  
  readonly barcode?: Maybe<string>;
  
  readonly cardFormat?: Maybe<string>;
  
  readonly cardId?: Maybe<string>;
  
  readonly cardType?: Maybe<string>;
  
  readonly details?: Maybe<CardDetails>;
  
  readonly loyaltyTransactions?: Maybe<LoyaltyTransactionListResponse>;
  
  readonly name?: Maybe<string>;
}


export interface CardDetails {
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: number;
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: boolean;
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: boolean;
  /** The type of loyalty card. */
  readonly cardType: string;
  /** (e.g. 0001-01-01T00:00:00Z) */
  readonly discountActiveUntil: string;
  /** Whether or not the round up donation toggle status is on */
  readonly donationUpcharge?: Maybe<boolean>;
  
  readonly numberOfTransactionsInTimePeriod: number;
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: number;
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: number;
  /** (e.g. 9899-12-31T23:59:59.9999999) */
  readonly periodEndTimestamp: string;
  /** (e.g. 1999-01-01T00:00:00) */
  readonly periodStartTimestamp: string;
  /** The user's available loyalty points. If the value is null, then the user has not been migrated to Loyalty 2.0 */
  readonly points?: Maybe<number>;
  /** The user's selected reward tier. If the value is null, then the user has not been migrated to Loyalty 2.0 */
  readonly rewardsTier?: Maybe<string>;
}


export interface LoyaltyTransactionListResponse {
  
  readonly count: number;
  
  readonly transactions?: Maybe<ReadonlyArray<Maybe<LoyaltyTransaction>>>;
}


export interface LoyaltyTransaction {
  /** Address Line 1 of store where loyalty was redeemed */
  readonly address1?: Maybe<string>;
  /** Address Line 2 of store where loyalty was redeemed */
  readonly address2?: Maybe<string>;
  /** Offers applied to this transaction */
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<string>>>;
  /** The taxes of the basket. */
  readonly basketTaxes?: Maybe<number>;
  /** The total of the basket including taxes. */
  readonly basketTotal?: Maybe<number>;
  /** Bonus points earned */
  readonly bonusPoints?: Maybe<number>;
  /** City of store where loyalty was redeemed */
  readonly city?: Maybe<string>;
  /** The total amount discounted */
  readonly discountAmount?: Maybe<number>;
  
  readonly expiredPoints?: Maybe<LoyaltyExpiredPoints>;
  /** True if this visit was given from customer support. False otherwise. */
  readonly isCustomerServiceVisit?: Maybe<boolean>;
  /** True if the transaction counted as a visit. */
  readonly isVisit?: Maybe<boolean>;
  /** Items purchased in this transaction. */
  readonly items?: Maybe<ReadonlyArray<Maybe<LoyaltyTransactionItem>>>;
  /** Offer that was associated with the transaction */
  readonly offerId?: Maybe<number>;
  /** Loyalty points earned from transaction */
  readonly pointsEarned?: Maybe<number>;
  /** Loyalty points used from transaction */
  readonly pointsUsed?: Maybe<number>;
  /** Postal code of the store where loyalty was redeemed */
  readonly postalCode?: Maybe<string>;
  /** Type of POS */
  readonly posType?: Maybe<string>;
  /** True if this transaction earned a rewards */
  readonly rewardEarned?: Maybe<boolean>;
  /** Reward redeemed upon transaction */
  readonly rewardRedeemed?: Maybe<boolean>;
  /** State or Province of store where loyalty was redeemed */
  readonly stateOrProvince?: Maybe<string>;
  /** Store ID where loyalty was redeemed */
  readonly storeId?: Maybe<string>;
  /** Tag name for loyalty transaction */
  readonly tag?: Maybe<string>;
  /** The time of the transaction in UTC. */
  readonly timestamp?: Maybe<string>;
  /** Timezone of store where loyalty was redeemed */
  readonly timezone?: Maybe<string>;
  /** A unique identifier for transaction */
  readonly transactionId?: Maybe<string>;
  /** A tag for the type of visit. This will be null for normal transactions. When a visit or reward is issued through the IssueVisit/IssueReward endpoints a VisitType may be specified that will surface in this field */
  readonly visitType?: Maybe<string>;
  /** True if the discount was active or available for this transaction. False if no discount was applied. */
  readonly wasDiscountActive?: Maybe<boolean>;
}


export interface LoyaltyExpiredPoints {
  /** Loyalty card barcode */
  readonly barcode?: Maybe<string>;
  
  readonly expirationDate?: Maybe<string>;
  
  readonly points?: Maybe<number>;
  
  readonly ttl?: Maybe<string>;
}


export interface LoyaltyTransactionItem {
  
  readonly basePrice?: Maybe<number>;
  
  readonly name?: Maybe<string>;
  
  readonly plu?: Maybe<string>;
  
  readonly totalPrice?: Maybe<number>;
  
  readonly uniqueId?: Maybe<string>;
}


export interface User {
  
  readonly email?: Maybe<string>;
  
  readonly roles?: Maybe<ReadonlyArray<Maybe<string>>>;
  /** Cognito ID */
  readonly userName: string;
}


export interface Mutation {
  
  readonly api?: Maybe<ApiMetadata>;
  
  readonly ctgLoyaltyCreatePersonalizedOffer?: Maybe<IntlLoyaltyPersonalizedOffer>;
  
  readonly ctgLoyaltyRemovePersonalizedOffer?: Maybe<boolean>;
  /** sign up a new customer */
  readonly customerSignUp: CustomerSignUpResult;
  
  readonly intlLoyaltyDeductPoints: number;
  
  readonly intlLoyaltyIssuePoints: number;
  
  readonly intlLoyaltyRemoveSecondaryIdentifier?: Maybe<IntlLoyaltySecondaryIdentifier>;
  /** record a remediation with type RemediationType.NONE on an order */
  readonly recordNonRemediation?: Maybe<boolean>;
  /** Refund an order partially or fully */
  readonly refundSale: RefundSale;
  /** block or unblock a customer */
  readonly updateCustomerBlockState?: Maybe<CustomerDetails>;
  /** update the date of birth on a user profile */
  readonly updateDob: UpdateDobResponse;
  /** update the email on a user profile */
  readonly updateEmail: UpdateEmailResponse;
}


export interface CustomerSignUpResult {
  
  readonly userConfirmed: boolean;
  
  readonly userSub: string;
}


export interface IntlLoyaltySecondaryIdentifier {
  
  readonly createdAt?: Maybe<string>;
  
  readonly id?: Maybe<string>;
  
  readonly identifier?: Maybe<string>;
  
  readonly identifierType?: Maybe<string>;
  
  readonly identifierVerified?: Maybe<boolean>;
  
  readonly loyaltyId?: Maybe<string>;
  
  readonly updatedAt?: Maybe<string>;
}


export interface RefundSale {
  
  readonly msgSentToQueue?: Maybe<boolean>;
}


export interface UpdateDobResponse {
  
  readonly customerId: string;
  
  readonly dob?: Maybe<string>;
}


export interface UpdateEmailResponse {
  
  readonly email: string;
  
  readonly newEmail: string;
  
  readonly region: string;
  
  readonly success?: Maybe<boolean>;
}


export interface Balance {
  
  readonly beginBalance?: Maybe<number>;
  
  readonly currentBalance?: Maybe<number>;
}


export interface Customer {
  
  readonly cognitoId?: Maybe<string>;
  
  readonly orders?: Maybe<OrderListResponse>;
}


export interface IssuedResponse {
  
  readonly rewards?: Maybe<number>;
  
  readonly succeeded: boolean;
  
  readonly visits?: Maybe<number>;
}


export interface IssueLoyaltyPointsResponse {
  
  readonly points: number;
  
  readonly succeeded: boolean;
}


export interface LoyaltyTier {
  
  readonly id?: Maybe<string>;
  
  readonly name?: Maybe<string>;
  
  readonly points?: Maybe<number>;
}


export interface OfferAssignedResponse {
  
  readonly succeeded: boolean;
}


export interface ResetOtpResponse {
  
  readonly succeeded: boolean;
}



// ====================================================
// Arguments
// ====================================================

export interface CustomerQueryArgs {
  
  customerId?: Maybe<string>;
  
  email?: Maybe<string>;
  
  resumeAfter?: Maybe<string>;
}
export interface CustomerByEmailQueryArgs {
  
  email: string;
}
export interface CustomerByLoyaltyIdQueryArgs {
  
  loyaltyId: string;
}
export interface CustomersByEmailQueryArgs {
  
  email: string;
}
export interface CustomersByPhoneNumberQueryArgs {
  
  phoneNumber: string;
}
export interface GetSupportUsersQueryArgs {
  
  paginationToken?: Maybe<string>;
}
export interface GuestLookupByEmailQueryArgs {
  
  email: string;
}
export interface GuestOrdersQueryArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  email: string;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  region?: Maybe<string>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface IntlCustomerLoyaltyTierConfigQueryArgs {
  
  loyaltyId: string;
}
export interface IntlLoyaltyIdByEmailQueryArgs {
  
  email: string;
}
export interface IntlLoyaltyOffersByLoyaltyIdQueryArgs {
  
  global?: Maybe<boolean>;
  
  loyaltyId: string;
}
export interface IntlLoyaltyTransactionQueryArgs {
  
  loyaltyId: string;
  
  shortId: string;
}
export interface IntlLoyaltyTransactionsQueryArgs {
  
  loyaltyId: string;
  
  resumeAfter?: Maybe<string>;
}
export interface IntlLoyaltyTransactionsWithRewardItemsQueryArgs {
  
  country: string;
  
  loyaltyId: string;
  
  resumeAfter?: Maybe<string>;
}
export interface IntlLoyaltyUserByIdQueryArgs {
  
  loyaltyId: string;
}
export interface LaunchDarklyFlagQueryArgs {
  
  country: string;
  
  customerId: string;
  
  flagName: string;
}
export interface LoyaltyByCustomerIdQueryArgs {
  
  customerId: string;
}
export interface LoyaltyByEmailQueryArgs {
  
  email: string;
}
export interface LoyaltyByThLegacyCognitoIdQueryArgs {
  
  thLegacyCognitoId: string;
}
export interface OrderQueryArgs {
  
  rbiOrderId: string;
}
export interface OrdersQueryArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  email: string;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface StoreQueryArgs {
  
  storeId: string;
}
export interface StoresQueryArgs {
  
  searchTerm: string;
}
export interface AssignedOffersCustomerDetailsArgs {
  
  rbiOrderId?: Maybe<string>;
  
  resumeAfter?: Maybe<string>;
}
export interface OrdersCustomerDetailsArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}
export interface OrdersByIdsCustomerDetailsArgs {
  
  orderIds?: Maybe<ReadonlyArray<Maybe<string>>>;
}
export interface RemediationsCustomerDetailsArgs {
  
  resumeAfter?: Maybe<string>;
}
export interface LoyaltyCardLoyaltyArgs {
  
  lastTransactionBarcode?: Maybe<string>;
  
  lastTransactionId?: Maybe<string>;
  
  lastTransactionTimestamp?: Maybe<string>;
  
  pageSize?: Maybe<number>;
}
export interface CtgLoyaltyCreatePersonalizedOfferMutationArgs {
  
  agentEmail?: Maybe<string>;
  
  cognitoId: string;
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  offerConfigId: string;
  
  offerName?: Maybe<string>;
  
  offerTemplateId: string;
  
  orderId?: Maybe<string>;
  
  reason: string;
}
export interface CtgLoyaltyRemovePersonalizedOfferMutationArgs {
  
  cognitoId: string;
  
  comments?: Maybe<string>;
  
  configId: string;
  
  loyaltyId: string;
  
  offerId: string;
  
  rbiOrderId?: Maybe<string>;
  
  reason: string;
}
export interface CustomerSignUpMutationArgs {
  
  accountType?: Maybe<string>;
  
  country: string;
  
  customerIp: string;
  
  dob?: Maybe<string>;
  
  forterMobileUID?: Maybe<string>;
  
  forterTokenCookie?: Maybe<string>;
  
  name?: Maybe<string>;
  
  phoneNumber?: Maybe<string>;
  
  userAgent: string;
  
  userName: string;
  
  wantsPromotionalEmails?: Maybe<boolean>;
  
  zipCode?: Maybe<string>;
}
export interface IntlLoyaltyDeductPointsMutationArgs {
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  loyaltyUserCognitoId: string;
  
  orderId?: Maybe<string>;
  
  points: number;
  
  reason: string;
}
export interface IntlLoyaltyIssuePointsMutationArgs {
  
  comments?: Maybe<string>;
  
  loyaltyId: string;
  
  loyaltyUserCognitoId: string;
  
  orderId?: Maybe<string>;
  
  points: number;
  
  reason: string;
}
export interface IntlLoyaltyRemoveSecondaryIdentifierMutationArgs {
  
  identifier: string;
  
  identifierType: string;
  
  loyaltyId: string;
}
export interface RecordNonRemediationMutationArgs {
  
  customerId: string;
  
  orderId: string;
  
  remediationComment: string;
  
  remediationReason: string;
}
export interface RefundSaleMutationArgs {
  
  input: RefundSaleInput;
}
export interface UpdateCustomerBlockStateMutationArgs {
  
  customerId: string;
  
  isBlocked: boolean;
}
export interface UpdateDobMutationArgs {
  
  customerId: string;
  
  dob: string;
}
export interface UpdateEmailMutationArgs {
  
  email: string;
  
  newEmail: string;
  
  region: string;
}
export interface OrdersCustomerArgs {
  
  createdAfter?: Maybe<string>;
  
  createdBefore?: Maybe<string>;
  
  limit?: Maybe<number>;
  
  orderStatuses?: Maybe<ReadonlyArray<Maybe<RbiOrderStatus>>>;
  
  resumeAfter?: Maybe<string>;
  
  sortAscending?: Maybe<boolean>;
}


